import PersonGroupService from "@/app/services/PersonGroupService.js"
import { types } from "@/app/types/types";

const state =
{
	[types.STATE_PERSONGROUPS]: []
};

const getters =
{
	[types.GET_PERSONGROUPS]: (state) =>
	{
		return state[types.STATE_PERSONGROUPS]
	},

	[types.GET_PERSONGROUP]: (state) => id =>
	{
		var persongroups = state[types.STATE_PERSONGROUPS];

		for (const persongroup of persongroups)
		{
			if (persongroup.id == id)
				return persongroup;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_PERSONGROUPS]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_PERSONGROUPS] = payload
	},

	[types.MUTATE_ADD_PERSONGROUP]: (state, payload) =>
	{
		state[types.STATE_PERSONGROUPS].push(payload);
	},

	[types.MUTATE_UPDATE_PERSONGROUP]: (state, payload) =>
	{
		//let index = state[types.STATE_PERSONGROUPS].findIndex(persongroup => persongroup.id == payload.id)
		//state[types.STATE_PERSONGROUPS].splice(index, 1, payload)
		let persongroup = state[types.STATE_PERSONGROUPS].find((persongroup) => { return persongroup.id == payload.id });

		if (persongroup)
		{
			persongroup = payload
		}
	},

	[types.MUTATE_DELETE_PERSONGROUP]: (state, payload) =>
	{
		//let index = state[types.STATE_PERSONGROUPS].findIndex(persongroup => persongroup.id == payload.id)
		//state[types.STATE_PERSONGROUPS].splice(index, 1)
		state[types.STATE_PERSONGROUPS] = state[types.STATE_PERSONGROUPS].filter((persongroup) => { return persongroup.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_PERSONGROUPS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PERSONGROUPS, payload: payload })
		
		return PersonGroupService.getPersonGroups(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_PERSONGROUPS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PERSONGROUPS, message: error, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PERSONGROUP, payload: payload })

		return PersonGroupService.getPersonGroup(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PERSONGROUP, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PERSONGROUP, message: error });
			return error.response
		});
	},

	[types.ACTION_ADD_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_PERSONGROUP, payload: payload })

		return PersonGroupService.addPersonGroup(payload).then(response =>
		{
			commit(types.MUTATE_ADD_PERSONGROUP, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_PERSONGROUP, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSONGROUP, payload: payload })

		return PersonGroupService.updatePersonGroup(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PERSONGROUP, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_PERSONGROUP, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DELETE_PERSONGROUP]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_PERSONGROUP, payload: payload })

		return PersonGroupService.deletePersonGroup(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_PERSONGROUP, payload);
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_PERSONGROUP, message: error.response.statusText, payload: payload });
			return error.response
		});
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
